var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 34.4167C27.5144 34.4167 34.4167 27.5144 34.4167 19C34.4167 10.4857 27.5144 3.58337 19 3.58337C10.4857 3.58337 3.58337 10.4857 3.58337 19C3.58337 27.5144 10.4857 34.4167 19 34.4167Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1459 14.3216C15.1459 13.5858 15.1459 13.2179 15.2996 13.0125C15.4336 12.8335 15.6388 12.7215 15.8618 12.7056C16.1177 12.6873 16.4272 12.8862 17.0461 13.2841L24.3237 17.9626C24.8608 18.3079 25.1294 18.4805 25.2221 18.7C25.3032 18.8918 25.3032 19.1083 25.2221 19.3001C25.1294 19.5196 24.8608 19.6922 24.3237 20.0375L17.0461 24.7159C16.4272 25.1138 16.1177 25.3128 15.8618 25.2945C15.6388 25.2786 15.4336 25.1666 15.2996 24.9876C15.1459 24.7822 15.1459 24.4143 15.1459 23.6785V14.3216Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.33ff0771041b50210feebbd76cf768a6.svg";
export { ForwardRef as ReactComponent };